<!-- <h1 class="h3 mb-3">Credit Report Summary Results</h1> -->

<div class="search-results">
  <p class="nav-back">
    <a class="nav-back__link" routerLink="/job-status/search">Back to Search</a>
  </p>
  <div class="card">
    <div class="card__section">
      <div class="row align-bottom">
        <div class="columns">
          <!-- <h1 class="typography--display1">Summary</h1> -->
          <h1 class="card__title card__title--large">Job Status Summary</h1>
        </div>
      </div>
    </div>
    <div class="card__section">
      <div class="display-options">
        <div class="display-options__count">
          Showing {{ (searchResultsState$ | async).pagingSorting.pageSize * ((searchResultsState$ | async).pagingSorting.currentPage - 1) + 1 }} -
          {{
            (searchResultsState$ | async).pagingSorting.pageSize > (searchResultsState$ | async).pagingSorting.totalCount
              ? (searchResultsState$ | async).pagingSorting.totalCount
              : (searchResultsState$ | async).pagingSorting.pageSize * (searchResultsState$ | async).pagingSorting.currentPage
          }}
          of
          {{ (searchResultsState$ | async).pagingSorting.totalCount }}
        </div>
        <label class="display-options__per-page">
          Show
          <select (change)="setPageSize($event.target.value)">
            <option value="15" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 15">15</option>
            <option value="25" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 25">25</option>
            <option value="50" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 50">50</option>
            <option value="100" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 100">100</option>
            <option value="200" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 200">200</option>
          </select>
        </label>
        <!--<input type="text" class="display-options__filter" placeholder="Type to filter..." aria-label="Type to filter">-->
        <div class="display-options__filter"></div>
        <div class="display-options__pagination">
          <ul class="pagination" role="navigation" aria-label="Pagination">
            <!--<li class="pagination__previous disabled">Previous<span class="show-for-sr"> page</span></li>-->
            <li class="pagination__previous" [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage <= 1">
              {{ (searchResultsState$ | async).pagingSorting.currentPage <= 1 ? 'Previous' : '' }}
              <a *ngIf="(searchResultsState$ | async).pagingSorting.currentPage > 1" aria-label="Previous page" (click)="prevPage()"
                >Previous<span class="show-for-sr"> page</span></a
              >
            </li>
            <li class="pagination__current">
              <span class="show-for-sr">You are on page </span>
              {{ (searchResultsState$ | async).pagingSorting.currentPage }}
            </li>
            <li aria-hidden="true">of</li>
            <li>
              <a aria-label="Page 10" (click)="lastPage()">{{ (searchResultsState$ | async).pagingSorting.totalPages }}</a>
            </li>
            <li
              class="pagination__next"
              [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages"
            >
              {{ (searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages ? 'Next' : '' }}
              <a
                *ngIf="(searchResultsState$ | async).pagingSorting.currentPage < (searchResultsState$ | async).pagingSorting.totalPages"
                aria-label="Next page"
                (click)="nextPage()"
                >Next<span class="show-for-sr"> page</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="full-page-spinner" [class.full-page-spinner--is-active]="(searchResultsState$ | async).loading">
      <div class="full-page-spinner__icon"></div>
    </div>

    <div class="card__section">
      <div class="table" role="table">
        <div role="rowgroup">
          <div class="table__row table__row--header" role="row">
            <span class="table__cell table__cell--half table__cell--align-left" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CreatedAt')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreatedAt' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CreatedAt' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Created Date
              </button>
            </span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="columnheader">
              <button
                class="table__sorter-btn table__sorter-btn--sorted-asc"
                (click)="sortBy('JobName')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'JobName' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'JobName' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Job Name
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('State')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'State' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'State' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                State
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('StartedAt')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'StartedAt' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'StartedAt' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Started At
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader" title="Social Security Number">
              <button
                class="table__sorter-btn"
                (click)="sortBy('CompletedAt')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CompletedAt' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'CompletedAt' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Completed At
              </button>
            </span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('Message')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'Message' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'Message' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Message
              </button>
            </span>
            <span class="table__cell table__cell--half" role="columnheader">
              <button
                class="table__sorter-btn"
                (click)="sortBy('TriggerType')"
                [class.table__sorter-btn--sorted-asc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'TriggerType' && (searchResultsState$ | async).pagingSorting.sortDir == 'Asc'
                "
                [class.table__sorter-btn--sorted-dsc]="
                  (searchResultsState$ | async).pagingSorting.sortBy == 'TriggerType' && (searchResultsState$ | async).pagingSorting.sortDir == 'Desc'
                "
              >
                Type
              </button>
            </span>
          </div>
        </div>
        <div role="rowgroup">
          <a
            class="table__row ng-scope"
            role="row"
            *ngFor="let jobStatus of (searchResultsState$ | async).response?.results; odd as isOdd; last as isLast"
            [class.table__row--alt]="isOdd"
            [class.table__row--last]="isLast"
            routerLink="/job-status/{{ jobStatus.id }}"
            opusAuthorize="JobStatus.ViewDetails"
          >
            <span class="table__cell table__cell--half table__cell--align-left" role="cell" [title]="jobStatus.createdDate | date : 'MM/dd/yyyy hh:mm:ss a'">
              {{ jobStatus.createdAt | date : 'MM/dd/yyyy hh:mm:ss a' }}
            </span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="cell">{{ jobStatus.jobName }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ getJobStateName(jobStatus.state) }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ jobStatus.startedAt | date : 'MM/dd/yyyy hh:mm:ss a' }}</span>
            <span class="table__cell table__cell--half" role="cell">{{ jobStatus.completedAt | date : 'MM/dd/yyyy hh:mm:ss a' }}</span>
            <span class="table__cell table__cell--align-left table__cell--one-half" role="cell">
              <span [title]="jobStatus.message">
                {{ jobStatus.message | slice : 0 : 50 - 1 }}
              </span>
            </span>
            <span class="table__cell table__cell--half" role="cell">{{ getTriggerTypeName(jobStatus.triggerType) }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="card__section">
      <div class="display-options">
        <div class="display-options__count">
          Showing {{ (searchResultsState$ | async).pagingSorting.pageSize * ((searchResultsState$ | async).pagingSorting.currentPage - 1) + 1 }} -
          {{
            (searchResultsState$ | async).pagingSorting.pageSize > (searchResultsState$ | async).pagingSorting.totalCount
              ? (searchResultsState$ | async).pagingSorting.totalCount
              : (searchResultsState$ | async).pagingSorting.pageSize * (searchResultsState$ | async).pagingSorting.currentPage
          }}
          of
          {{ (searchResultsState$ | async).pagingSorting.totalCount }}
        </div>
        <label class="display-options__per-page">
          Show
          <select (change)="setPageSize($event.target.value)">
            <option value="15" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 15">15</option>
            <option value="25" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 25">25</option>
            <option value="50" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 50">50</option>
            <option value="100" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 100">100</option>
            <option value="200" [selected]="(searchResultsState$ | async).pagingSorting.pageSize == 200">200</option>
          </select>
        </label>
        <!--<input type="text" class="display-options__filter" placeholder="Type to filter..." aria-label="Type to filter">-->
        <div class="display-options__filter"></div>
        <div class="display-options__pagination">
          <ul class="pagination" role="navigation" aria-label="Pagination">
            <!--<li class="pagination__previous disabled">Previous<span class="show-for-sr"> page</span></li>-->
            <li class="pagination__previous" [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage <= 1">
              {{ (searchResultsState$ | async).pagingSorting.currentPage <= 1 ? 'Previous' : '' }}
              <a *ngIf="(searchResultsState$ | async).pagingSorting.currentPage > 1" aria-label="Previous page" (click)="prevPage()"
                >Previous<span class="show-for-sr"> page</span></a
              >
            </li>
            <li class="pagination__current">
              <span class="show-for-sr">You are on page </span>
              {{ (searchResultsState$ | async).pagingSorting.currentPage }}
            </li>
            <li aria-hidden="true">of</li>
            <li>
              <a aria-label="Page 10" (click)="lastPage()">{{ (searchResultsState$ | async).pagingSorting.totalPages }}</a>
            </li>
            <li
              class="pagination__next"
              [class.disabled]="(searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages"
            >
              {{ (searchResultsState$ | async).pagingSorting.currentPage >= (searchResultsState$ | async).pagingSorting.totalPages ? 'Next' : '' }}
              <a
                *ngIf="(searchResultsState$ | async).pagingSorting.currentPage < (searchResultsState$ | async).pagingSorting.totalPages"
                aria-label="Next page"
                (click)="nextPage()"
                >Next<span class="show-for-sr"> page</span></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
